import { Link } from 'react-router-dom'
import { Grid, Image } from 'antd'
import { LanguageSelector } from './LanguageSelector'

export const HeaderAuth = () => {
  const { md } = Grid.useBreakpoint()

  return (
    <header className='border-b border-[#d9d9d9] bg-white px-6'>
      <div className='mx-auto flex h-[60px] max-w-[1200px] items-center justify-between md:h-[80px]'>
        <Link
          to='/'
          className='flex items-center'
        >
          <Image
            src='/images/logoTeleHealth.png'
            alt='Tap Telehealth'
            height={md ? 33 : 22}
            width={md ? 70 : 47}
            preview={false}
          />
        </Link>

        <LanguageSelector />
      </div>
    </header>
  )
}
